import { assertNever } from 'owa-assert';
export function mapTableQueryToTableViewOptions(tableQuery) {
    switch (tableQuery.type) {
        case 1 /* Search */:
            return getSearchTableQueryOptions(tableQuery);
        case 0 /* Folder */:
        case 2 /* Group */:
            return getMailTableQueryOptions(tableQuery);
        default:
            return assertNever(tableQuery.type);
    }
}
function getSearchTableQueryOptions(tableQuery) {
    switch (tableQuery.scenarioType) {
        case 'mail':
        case 'messageSuggestion':
            return { shouldHighlight: true, headerGeneratorType: 'RelevanceHybrid' };
        case 'persona':
        case 'category':
            return { shouldHighlight: false, headerGeneratorType: 'DateTime' };
        default:
            return assertNever(tableQuery.scenarioType);
    }
}
function getMailTableQueryOptions(tableQuery) {
    var headerGeneratorType;
    var tableSortColumn = tableQuery.type == 0 /* Folder */ &&
        tableQuery.sortBy.sortColumn;
    switch (tableSortColumn) {
        case 1 /* From */:
            headerGeneratorType = 'Sender';
            break;
        case 2 /* Size */:
            headerGeneratorType = 'Size';
            break;
        case 0 /* Date */:
        default: // always fall back to date header generator
            {
                headerGeneratorType = 'DateTime';
                break;
            }
    }
    return { shouldHighlight: true, headerGeneratorType: headerGeneratorType };
}
//# sourceMappingURL=mapTableQueryToTableViewOptions.js.map